export const LOGIN = "/login";
export const FORGOTPASSWORD = "/forgot-password";
export const RESETPASSWORD = "/reset-password";
export const DASHBOARD = "/dashboard";
export const ADDNEWLEAD = "/add-new-lead";
export const LEADLIST = "/leadList";
export const LEADPOOL = "/lead-pool";
export const ADDLEADEXISTCOMPANY = "/add-lead-to-existing-company";
export const COMPANIES = "/companies";
export const ADDNEWCOMPANY = "/add-new-company-form";
export const ADDNEWPOC = "/add-new-poc";
export const ADDCOMPANYPOC = "/add-new-company-poc";
export const ROLES = "/roles";
export const PAGES = "/pages";
export const USERS = "/users";
export const NEWROLE = "/new-role";
export const NEWPAGE = "/new-page";
export const PROFILE = "/profile";
export const SUPPORT = "/support";
export const TICKETDETAIL = "/ticket-detail";
export const COMPANY = "/company";
export const MYLEADS = "/my-leads";
export const POC = "/poc";
export const LeadAssignReport = "/assign-report";
export const LeadCreationReport = "/creation-report";
export const EMPLOYEEPERFORMANCE = "/employee-performance-report";
export const COMPARISONCHART = "/comparison-chart";
export const EMAILSETTING = "/email-settings";
export const GSTSETTING = "/gst-setting";
export const UpdatePassword = "/update-password";
export const EXTRACTFORMCONTENT = "/extract-form-content";
export const LEADDETAIL = "/lead-details";
export const MYLEADEDIT = "/my-lead-edit";

export const INDUSTRYTYPES = "/master/industry-types";
export const DESIGNATION = "/master/designation";
export const COUNTRY = "/master/country";
export const STATE = "/master/state";
export const CITY = "/master/city";
export const SOURCE = "/master/source";
export const STATUS = "/master/status";
export const TEAMMANAGEMENT = "/master/team-management";
export const SALESSTAGE = "/master/sales-stage";
export const ADDMEMBER = "/master/add-member";
export const LEADREQUIREMENT = "/lead-requirement";
export const MYTEAMLEAD = "/my-team-lead";
export const SERVICEINTERESTEDIN = "/master/service-intrested";
export const FIELDMASKINGSETTING = "/master/field-masking-setting";
export const PRODUCT = "/master/product";
export const WEBSITESETTINGS = "/master/website-settings";
export const SOURCEWISEREPORT = "/source-wise-report";
export const TASKMANAGEMENT = "/task-management";
export const MYTASK = "/my-task";
export const REVIEWTASK = "/review-task";

export const ADDQUICKCOMPANYPOC = "/quick-lead";
export const COUNTRYASSIGNEDMEMBERS = "/CountryAssignedMember";
export const SOURCEASSIGNEDMEMBERS = "/SourceAssignedMember";
export const DUPLICATELEADSETTINGS = "/Duplicateleadsettings";
export const DUPLICATELEAD = "/Duplicatelead";
export const EMAITEMPLATE = "/EmailTemplate";
export const LEADACCEPTANCEHISTORY = "/lead-acceptance-history";
export const BULKUPLOADLEAD = "/bulk-upload-lead";
export const MEETING = "/meetings";

export const FOLLOWUPLIST = "/reminders-list";
export const SIGNATURE = "/signature";
export const CREATEDLEAD = "/created-lead";
export const MYTEAMCREATEDLEAD = "/my-team-created-lead";
export const TARGET = "/target";
export const PROJECT = "/projects";
export const PROJECTDETAIL = "/project-details";
export const SERVICETEAMMANAGEMENT = "/service-team-management";
export const SERVICEADDMEMBER = "/master/service-add-member";
export const RESOURCEBANDWIDTHPROJECTCOST = "/resource-bandwidth-project-cost";
export const RESOURCEREVENUEREPORT = "/resource-revenue-report";
export const MYPROJECT = "/my-project";
export const ALLOCATEDPROJECT = "/allocated-project";
export const ALLOCATEDPROJECTDETAIL = "/allocated-project-details";
export const LOCATIONMASTER = "/master/location-master";
export const AGENCY = "/master/agency";
export const ADDNEWAGENCY = "/master/add-new-agency";
export const ADDAGENCYPOC = "/master/add-agency-poc";
export const MILESTONE = "/master/milestone";
export const MILESTONEMASTER = "/master/milestone-master";
export const TASKTYPEMASTER = "/master/task-type-master";
export const TASKSTATUSMASTER = "/master/task-status-master";
export const DISQUALIFYREASON = "/master/disqualify-reason";
export const ALLTASK = "/all-Task";
export const MYTASKTIMESHEET = "/myTask_timeSheet";
export const RECURRINGTASKTIMESHEET = "/recurring-task-timesheet";
export const ALLTASKDETAIL = "/alltask_detail";

export const CUSTOMERLIST = "/customers";
export const CUSTOMERDETAIL = "/customers/:id";
export const DEPARTMENT = "/master/department";

export const TASKNOTIFICATIONSETTINGS = "/tasknotificationSettings";
export const INVOICELISTPAGE = "/invoice-list-page";
export const AllBillingPlans="/allBillingPlans"
